import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const o = e([
  "container",
  "mobileMenuContent",
  "mobileMenuBody",
  "mobileMenuHeader"
]), n = o.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      paddingX: { base: 4, md: 6 },
      alignItems: "center",
      height: "60px",
      flexDir: "row",
      borderBottomWidth: "1px",
      borderBottomColor: "gray.200"
    },
    mobileMenuContent: {
      borderRadius: "none",
      borderWidth: 0,
      boxShadow: "none",
      overflow: "auto"
    },
    mobileMenuBody: {
      paddingX: 0,
      paddingY: 4,
      maxWidth: "unset"
    },
    mobileMenuHeader: {
      bg: "gray.50",
      paddingY: 4,
      paddingX: 6,
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      textAlign: "center",
      backgroundSize: "auto 100%"
    }
  },
  variants: {},
  defaultProps: {}
});
export {
  n as default
};
